import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { SosService } from '../../core/services/sos.service';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { FoundationServiceService } from '../../features/services/foundation-service.service';
import { ToasterService } from '../../shared/toaster.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-main-navbar',
  templateUrl: './main-navbar.component.html',
  styleUrl: './main-navbar.component.scss',
})
export class MainNavbarComponent implements OnInit {
  isAuthenticated = false;
  username = '';

  // ← Add this:
  mobileMenuOpen = false; // ← boolean flag for mobile menu
  canApplyService: boolean = false;
  canViewFreeZones: boolean = false;

  constructor(
    private authService: AuthService,
    private sosService: SosService,
    private router: Router,
    private foundationService: FoundationServiceService,
    private toaster: ToasterService,
  ) {}

  ngOnInit(): void {
    this.authService.authState$.subscribe((isAuth) => {
      this.isAuthenticated = isAuth;
      this.username = isAuth ? this.authService.getUsername() : '';
    });

    this.foundationService.canProgressServices().subscribe((response) => {
      this.canApplyService = response.data;
    });
    if(this.isAuthenticated)
    this.foundationService.canGoToFreeZone().subscribe((response) => {
      this.canViewFreeZones = response.data;
    });
  }

  goToEServices(): void {
    if (!this.canApplyService) {
      this.showServiceDownWarning();
      return;
    }

    this.router.navigate(['/services/eServices']);
  }

  goToFreeZones(): void {
    this.router.navigate(['auth/login']);  
  }

  private showServiceDownWarning(): void {
    Swal.fire({
      title: 'تنبيه / Notice',
      icon: 'info',
      html: `
        <div style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    text-align: center;
                    direction: rtl;
                    line-height: 1.6;
                    padding: 0 20px;
                    max-width: 100%;">

          <!-- Logo -->
         <!--
         <img src="http://www.gafi.gov.eg/Style%20Library/linkdevCustomImg/images/logo-1.png"
               alt="شعار الهيئة العامة للاستثمار والمناطق الحرة"
               style="max-width: 180px; margin: 0 auto 20px; display: block;">
               -->

          <!-- Authority Name - Bigger width popup + RED color -->
          <h2 style="margin: 0 0 20px; font-size: 1.5rem; font-weight: bold; color: #c8102e;">
            الهيئة العامة للاستثمار والمناطق الحرة
          </h2>

          <!-- Arabic part -->
          <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
            السادة العملاء
          </h3>
          <p style="margin: 0 0 24px; font-size: 1.1rem;">
          لضمان جودة تقديم الخدمة ، يرجى العلم أن الخدمة متاحة طيلة أيام الأسبوع فيما عدا يومي الجمعة والسبت وكذلك الأجازات والعطلات الرسمية.
        </p>

          <!-- Separator -->
          <hr style="border: 0; border-top: 1px solid #ccc; margin: 24px 0;">

          <!-- English part -->
          <h3 style="margin: 12px 0 8px; font-size: 1.2rem; font-weight: 600;">
            Dear Customers
          </h3>
          <p style="margin: 0; font-size: 1.1rem;">
            To ensure quality service, please note that the service is currently unavailable.<br>
            It is available all days of the week, except Fridays and Saturdays, as well as official holidays.
          </p>
        </div>
      `,
      confirmButtonText: 'حسناً / OK',
      confirmButtonColor: '#3CBACB',
      allowOutsideClick: true,
      allowEscapeKey: true,
      showCloseButton: true,
      width: '620px', // ← Increased width here
      customClass: {
        popup: 'service-notice-popup',
      },
    });
  }

  logout(): void {
    this.authService.logout();
  }

  // startSso() {
  //   if (this.isAuthenticated) {
  //     this.sosService.startSosSession();
  //   } else {
  //     // this.router.navigate(['auth/login']);
  //     window.location.href = environment.freeZonesUrl;
  //   }
  // }

  // Optional: nice to have - close menu when user clicks a link on mobile
  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }
  
  getFullName() {
    return this.authService.getFullName();
  }
}
